<style>
</style>

<template>
    <input 
        type="tel"
        :value="modelValue"
        @input="emitValue" 
    />
</template>

<script>
    export default {
        props: {
            modelValue: String,
            modelModifiers: {
                default: () => ({}), 

            }
        },
        emits: ['update:modelValue'],
        methods: {
            emitValue(e) {
                let value = e.target.value;
                let valueTrimmed = value.replace(/\D/g, '');
                let valueFormatted = valueTrimmed;
                    
                if(this.modelModifiers['format-phone']) {
                    
                    if(valueTrimmed.length >= 10) {
                        valueFormatted = '(' + valueTrimmed.slice(0,3) + ') ' + valueTrimmed.slice(3,6) + "-" + valueTrimmed.slice(6,10);
                    } 
                    else if(valueTrimmed.length > 6) {
                        valueFormatted = '(' + valueTrimmed.slice(0,3) + ') ' + valueTrimmed.slice(3,6) + "-" + valueTrimmed.slice(6);
                    }
                    else if(valueTrimmed.length > 3) {
                        valueFormatted = '(' + valueTrimmed.slice(0,3) + ') ' + valueTrimmed.slice(3);
                    }
                }

                this.$emit('update:modelValue', valueFormatted)
                this.$forceUpdate();

            }
        },
        created() { 
        }
    }
</script>